import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../utils/api';

const initialState = {
    data: null,
    isLoading: true,
    error: null
};

export const fetchRepsData = createAsyncThunk('data/fetchRepsData', async () => {
    try {
        const response = await apiRequest('get', 'users');
        return response;
    } catch (error) {
        throw error?.response?.data?.message || error?.response?.data || error?.message;
    }
});

const repSlice = createSlice({
    name: 'rep',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRepsData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchRepsData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload?.data;
            })
            .addCase(fetchRepsData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error;
            });
    }
});

export default repSlice.reducer;
